import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      balance: {
        withdrawal: {
          back: 'WITHDRAWAL_BACK',
          payment_details_form: {
            approve_default_payment_system: {
              title: 'APPROVE_TITLE',
              question: 'APPROVE_QUESTION',
              ok: 'APPROVE_OK',
              cancel: 'APPROVE_CANCEL',
            },
            submit_button: 'WITHDRAWAL_SUBMIT',
            select_payment_system: 'WITHDRAWAL_SELECT',
            default_payment_system: 'WITHDRAWAL_DEFAULT',
            epayments: {
              wallet: 'epayments.wallet',
            },
            neteller: {
              username: 'neteller.username',
              email: 'neteller.email',
            },
            paypal: {
              username: 'paypal.username',
              email: 'paypal.email',
            },
            webmoney: {
              username: 'webmoney.username',
              wallet: 'webmoney.wallet',
            },
            bank_transfer: {
              country_code: 'bank_transfer.country_code',
              company_name: 'bank_transfer.company_name',
              company_country: 'bank_transfer.company_country',
              company_city: 'bank_transfer.company_city',
              company_address: 'bank_transfer.company_address',
              company_postal: 'bank_transfer.company_postal',
              bank_name: 'bank_transfer.bank_name',
              bank_country: 'bank_transfer.bank_country',
              bank_address: 'bank_transfer.bank_address',
              bank_city: 'bank_transfer.bank_city',
              iban: 'bank_transfer.iban',
              bic: 'bank_transfer.bic',
              account_holders_name: 'bank_transfer.account_holders_name',
              branch_code: 'bank_transfer.branch_code',
              routing_number: 'bank_transfer.routing_number',
            },
            bank_card: {
              username: 'bank_card.username',
              card_number: 'bank_card.card_number',
              bank_name: 'bank_card.bank_name',
              country: 'bank_card.country',
              city: 'bank_card.city',
              address: 'bank_card.address',
              iban: 'bank_card.iban',
              bic: 'bank_card.bic',
              swift: 'bank_card.swift',
            },
            yandex_money: {
              wallet: 'yandex_money.wallet',
            },
            qiwi: {
              phone_number: 'qiwi.phone_number',
            },
            capitalist: {
              wallet: 'capitalist.wallet',
            },
            usdt_erc20: {
              wallet: 'usdt_erc20.wallet',
            },
            usdt_trc20: {
              wallet: 'usdt_trc20.wallet',
            },
            skrill: {
              username: 'skrill.username',
              email: 'skrill.email',
            },
            player_account: {
              poker_nickname: 'player_account.poker_nickname',
            },
            bitcoin: {
              wallet: 'bitcoin.wallet',
            },
          },
        },
      },
    },
  }));
}
